import React, { useState, useEffect} from "react";
import '../App.css'
import { formatToBRL } from "../utils/MonetaryUtils";

function InputMonetary(props) {
    const [display, setDisplay] = useState(formatToBRL(props.value || "0.00"));

    function handleChange(e) {
        const raw = e.target.value;
        const numeric = raw.replace(/\D/g, '');

        if (!numeric) {
            setDisplay('');
            props.onChange("0.00");
            return;
        }

        const decimalValue = (Number(numeric) / 100).toFixed(2);
        setDisplay(formatToBRL(numeric));
        props.onChange(decimalValue); // ex: "1234.56"
    }

    useEffect(() => {
        setDisplay(formatToBRL(props.value || "0.00"));
      }, [props.value]);

    return (
        <div className="input-group" style={{ "width": props.width || '30%' }} >
            <input
                {...props}
                id={props.id}
                style={props.error ? { "border-bottom": "2px solid red" } : {}}
                type="text"
                value={display}
                onChange={handleChange}
                inputMode="numeric"
                placeholder="R$ 0,00"
            />
            <label htmlFor={props.id} style={props.error ? {"color": "red"}: {}}>{props.label}</label>
        </div>
    );
}

export default InputMonetary;
